var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isTitleVisible())?_c('div',[_c('hr'),_c('p',{staticClass:"title"},[_vm._v("\n            "+_vm._s(_vm.getTitle())+"\n        ")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }